<template>
  <div>
    <i class="file-delete mdi mdi-close-circle-outline" @click="deleteFileConfirm()"></i>
    <!-- Modal (popup) for taking controll over the case -->
    <card-modal-component
      :show="showConfirmationModal"
      @deactivate="toggleConfirmationModal()"
      ref="confirmationModal"
      :title="`Delete file`">
      <translate slot="card-content" :translate-params="{file_name: file.name}">
        Are you sure you want to delete file: %{ file_name }?
      </translate>
      <div class="field is-grouped" slot="card-footer">
        <div class="control">
          <submit-btn-component class="is-primary" slot="card-footer" @submit="deleteFileHandler">Continue</submit-btn-component>
        </div>
        <div class="control">
          <button class="button is-danger is-outlined" slot="card-footer" @click="toggleConfirmationModal" v-translate>Cancel</button>
        </div>
      </div>
    </card-modal-component>
  </div>
</template>
<script>
  import { mapActions } from 'vuex'
  import File from '@/classes/case/File'
  import { Document } from '@/classes/case/Document'
  import CardModalComponent from '@/components/layout/modal/CardModalComponent'
  import SubmitBtnComponent from '@/components/layout/utility/SubmitBtnComponent'

  export default {
    name: 'delete-file-component',
    components: {
      CardModalComponent,
      SubmitBtnComponent
    },
    data () {
      return {
        showConfirmationModal: false
      }
    },
    props: {
      document: {
        type: Document,
        required: true
      },
      file: {
        type: File,
        required: true
      }
    },
    methods: {
      ...mapActions([
        'deleteFile',
        'successMessage'
      ]),
      toggleConfirmationModal () {
        this.showConfirmationModal = !this.showConfirmationModal
      },
      deleteFileFromDocument () {
        this.document.files = this.document.files.filter(file => file.uuid !== this.file.uuid)
      },
      deleteFileConfirm (file, key, index) {
        this.toggleConfirmationModal()
      },
      deleteFileHandler (btn) {
        this.deleteFile(this.file.deleteUrl).then(() => {
          this.showConfirmationModal = false
          this.$refs.confirmationModal.closeModal().then(() => {
            this.successMessage(this.$gettext('The file was deleted successfully.'))
            this.deleteFileFromDocument()
            this.$emit('fileDeleted', this.file)
          })
        }).catch((err) => {
          this.handleError(err)
        }).finally(() => {
          btn && btn.enable()
        })
      }
    }
  }
</script>
<style lang="sass" scoped>
  .file-delete
    margin-left: 0.5rem
    font-size: 1.5em
    color: gray
    cursor: pointer
</style>
